export default __webpack_public_path__ + "static/Moderat-Mono-Medium-b89498da90813568a1e425aced137498.woff2";